// Store für die Opt-in Auto-Rekey-Fenster (siehe internal/rekey). Ein
// Fenster ist zeitlich begrenzt aktiv; solange akzeptiert der Server
// einen geänderten SSH-Host-Key des Hosts automatisch (nach einem
// bewussten OpenWrt-Reflash). Diese Sicht zeigt die aktiven Fenster und
// bietet öffnen/schließen.
//
// Seit 02.11.2026 ohne eigenen Abruf und Takt: die offenen Fenster stehen in
// netz.lage über das Homelab-Protokoll (docs/protokoll.md › „Netzwerk über das
// Protokoll“) im gemeinsamen Netz-Stand (netz.svelte.ts); REST beim Start und
// sofort nach öffnen/schließen.

import { postJSON } from "./api";
import { getNetzRekey, refreshNetz, startNetz } from "./netz.svelte";

export interface RekeyWindow {
  host: string;
  expires_at: string; // RFC3339
  opened_at: string;
  opened_by: string;
  reason: string;
}

let _off: (() => void) | undefined;

export function startRekeyWindows(): void {
  if (_off) return;
  _off = startNetz();
}

export function stopRekeyWindows(): void {
  _off?.();
  _off = undefined;
}

/** Alle aktuell offenen Fenster (der Server filtert abgelaufene raus). */
export function getRekeyWindows(): RekeyWindow[] {
  return getNetzRekey() ?? [];
}

/** Aktives Fenster für einen bestimmten Host, oder null. */
export function rekeyWindowFor(host: string): RekeyWindow | null {
  return getRekeyWindows().find((w) => w.host === host) ?? null;
}

export async function openRekeyWindow(
  server: string,
  minutes = 60,
  reason = "",
): Promise<void> {
  await postJSON("/v2-api/security/rekey-window/open", {
    server,
    minutes,
    reason,
  });
  await refreshNetz(["rekey"]);
}

export async function closeRekeyWindow(server: string): Promise<void> {
  await postJSON("/v2-api/security/rekey-window/close", { server });
  await refreshNetz(["rekey"]);
}
